import { SITE_URL } from "./seo";

// Temporarily hiding the phone number everywhere it is published, including
// structured data. Flip to true to bring it back on every surface at once.
export const SHOW_PHONE = false;

export const NAP = {
  legalName: "LAA Concierge Consulting, LLC",
  street: "300 S 4th St, Ste 180",
  city: "Las Vegas",
  region: "NV",
  postalCode: "89101",
  country: "US",
  phone: "(702) 344-4716",
  phoneHref: "tel:+17023444716",
  email: "info@laaconsulting.com",
  hours: "Mon–Fri 9:00 AM – 5:00 PM",
  latitude: 36.1673,
  longitude: -115.1442,
} as const;

/** The contact line we publish. Phone while SHOW_PHONE is on, email otherwise. */
export const PUBLIC_CONTACT = SHOW_PHONE ? NAP.phone : NAP.email;

/** "call (702) …" / "email info@…" — the urgent-contact phrasing that matches PUBLIC_CONTACT. */
export const PUBLIC_CONTACT_ACTION = SHOW_PHONE ? `call ${NAP.phone}` : `email ${NAP.email}`;

/** Where we work: the city we are based in, the state, and the country we serve remotely. */
export const AREA_SERVED = [
  { "@type": "City", name: "Las Vegas" },
  { "@type": "State", name: "Nevada" },
  { "@type": "Country", name: "United States" },
];

const postalAddress = {
  "@type": "PostalAddress",
  streetAddress: NAP.street,
  addressLocality: NAP.city,
  addressRegion: NAP.region,
  postalCode: NAP.postalCode,
  addressCountry: NAP.country,
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: NAP.legalName,
  alternateName: "LAA Consulting",
  url: SITE_URL,
  ...(SHOW_PHONE ? { telephone: NAP.phone } : {}),
  email: NAP.email,
  address: postalAddress,
};

export const professionalServiceSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${SITE_URL}/#professionalservice`,
  name: NAP.legalName,
  url: SITE_URL,
  ...(SHOW_PHONE ? { telephone: NAP.phone } : {}),
  email: NAP.email,
  address: postalAddress,
  areaServed: { "@type": "Country", name: "United States" },
  parentOrganization: { "@id": `${SITE_URL}/#organization` },
};

export const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  name: "LAA Concierge Consulting",
  url: SITE_URL,
  publisher: { "@id": `${SITE_URL}/#organization` },
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#localbusiness`,
  name: NAP.legalName,
  url: SITE_URL,
  ...(SHOW_PHONE ? { telephone: NAP.phone } : {}),
  email: NAP.email,
  address: postalAddress,
  geo: {
    "@type": "GeoCoordinates",
    latitude: NAP.latitude,
    longitude: NAP.longitude,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "17:00",
    },
  ],
  areaServed: AREA_SERVED,
};
